import { apiClient, unwrap } from '@services/api';
import type { Cart, Category, Product } from '@/types';

export const catalogService = {
  async getCategories(): Promise<Category[]> {
    const res = await apiClient.get<Category[]>('/categories');
    return unwrap(res);
  },

  async getProducts(params?: { wholesalerId?: string; category?: string }): Promise<Product[]> {
    const res = await apiClient.get<Product[]>('/products/browse', { params });
    return unwrap(res);
  },

  async getMyProducts(): Promise<Product[]> {
    const res = await apiClient.get<Product[]>('/products/me');
    return unwrap(res);
  },

  async getProduct(id: string): Promise<Product> {
    const res = await apiClient.get<Product>(`/product/${id}`);
    return unwrap(res);
  },

  async createProduct(data: Partial<Product>): Promise<Product> {
    const res = await apiClient.post<Product>('/products', data);
    return unwrap(res);
  },

  async updateProduct(id: string, data: Partial<Product>): Promise<Product> {
    const res = await apiClient.patch<Product>(`/products/${id}`, data);
    return unwrap(res);
  },

  async deleteProduct(id: string): Promise<void> {
    await apiClient.delete(`/products/${id}`);
  },

  async scanBarcode(barcode: string): Promise<Product> {
    const res = await apiClient.get<Product>(
      `/wholesaler/product/scan/${encodeURIComponent(barcode)}`,
    );
    return unwrap(res);
  },
};

export const cartService = {
  async getCart(): Promise<Cart> {
    const res = await apiClient.get<Cart>('/cart');
    return unwrap(res);
  },

  async addItem(productId: string, quantity: number): Promise<Cart> {
    const res = await apiClient.post<Cart>('/cart/items', { productId, quantity });
    return unwrap(res);
  },

  async updateItem(itemId: string, quantity: number): Promise<Cart> {
    const res = await apiClient.patch<Cart>(`/cart/items/${itemId}`, { quantity });
    return unwrap(res);
  },

  async removeItem(itemId: string): Promise<Cart> {
    const res = await apiClient.delete<Cart>(`/cart/items/${itemId}`);
    return unwrap(res);
  },

  async clearCart(): Promise<Cart> {
    const res = await apiClient.delete<Cart>('/cart');
    return unwrap(res);
  },
};
